import { render, staticRenderFns } from "./SimilarPlayers.vue?vue&type=template&id=1478e168&"
import script from "./SimilarPlayers.vue?vue&type=script&lang=js&"
export * from "./SimilarPlayers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports